import React, { useState, useContext } from 'react';
import { Spinner, ButtonPrimary } from '../StyledComponent';

import BaseComponentChangeData from '../BaseComponentChangeData';

import FoundEmail from './FoundEmail';
import changeEmailRequest from '../../services/changeEmailRequests';
import './styles.scss';
import Input from '../Input';
import { ContextoListaApartamentos } from '../ApartamentList/contextoImoveis';
import { useHistory } from 'react-router-dom';
import { ChangeEmailContainer } from './styles';
import NeedHelp from '../NeedHelp';
import { validarEmail } from '../../Utils/validations';
import HeaderSection from '../HeaderSection';
import MessagePopUp from '../MessagePopup';

const ChangeEmail = () => {
  const [newEmail, setNewEmail] = useState('');
  const [confirmNewEmail, setConfirmNewEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [foundEmail, setFoundEmail] = useState(false);
  const [userCpf, setUserCpf] = useState('');
  const [errorUserAlreadyRegistered, setErrorUserAlreadyRegistered] =
    useState(false);

  const [validations, setValidations] = useState({
    newEmail: true,
    emailsEquals: true,
  });
  const { tema } = useContext(ContextoListaApartamentos);

  const history = useHistory();

  function cadastraNovoEmail() {
    (async function () {
      setLoading(true);

      // retorna email novo ou se for o mesmo que já esté em temp_email retorna o do temp e-mail
      const result = await changeEmailRequest.changeEmail(
        newEmail.replaceAll(' ', '')
      );

      if (result === undefined) {
        setErrorUserAlreadyRegistered(true);
      } else {
        setUserCpf(result.senha);

        toggleFoundEmail();
      }

      setLoading(false);
    })();
  }

  function validateEmail() {
    setValidations({ ...validations, newEmail: validarEmail(newEmail) });
  }

  function validateEmailsEquals() {
    setValidations({
      ...validations,
      emailsEquals: newEmail === confirmNewEmail,
    });
  }
  function toggleFoundEmail() {
    setFoundEmail(!foundEmail);
  }

  return (
    <>
      {foundEmail ? (
        <FoundEmail
          cpf={userCpf}
          email={newEmail}
          toggleFoundEmail={toggleFoundEmail}
        />
      ) : (
        <BaseComponentChangeData>
          <ChangeEmailContainer>
            <HeaderSection
              notShowButton
              tema={tema}
              title={'Altere seu e-mail'}
              subtitle={
                'Adicione abaixo o novo e-mail que você deseja utilizar para acessar o Pode Morar:'
              }
            />
            <div>
              <div>
                <Input
                  type='email'
                  labelName='Novo e-mail'
                  placeholder='Digite o seu novo e-mail'
                  marginTop={24}
                  handleInputChange={(e) => {
                    setNewEmail(e.target.value.replace(/\s/g, ''));
                  }}
                  onBlur={validateEmail}
                  error={!validations?.emailsEquals || !validations?.newEmail}
                  errorMessage={!validations?.newEmail ? 'Email inválido' : ''}
                  disabled={loading}
                />
              </div>
              <div>
                <Input
                  type='email'
                  labelName='Confirme seu novo e-mail'
                  placeholder='Digite e confirme o seu novo e-mail'
                  marginTop={16}
                  handleInputChange={(e) => {
                    setConfirmNewEmail(e.target.value.replace(/\s/g, ''));
                  }}
                  onBlur={validateEmailsEquals}
                  error={!validations?.emailsEquals}
                  errorMessage={'Os e-mails devem ser iguais'}
                  disabled={loading}
                />
              </div>
            </div>

            <div className='buttonsContainer'>
              <ButtonPrimary
                tema={tema}
                light
                disabled={loading}
                onClick={() => history.push('/meu-perfil')}
                id='btnCancelarAlteracaoEmail'
                fullWidth
              >
                Cancelar
              </ButtonPrimary>
              <ButtonPrimary
                tema={tema}
                disabled={
                  loading ||
                  newEmail === '' ||
                  confirmNewEmail === '' ||
                  !validations?.emailsEquals
                }
                onClick={cadastraNovoEmail}
                id='btnSalvarNovoEmail'
                fullWidth
              >
                ALTERAR E-MAIL
                {loading && <Spinner />}
              </ButtonPrimary>
            </div>
            <NeedHelp tema={tema} />
          </ChangeEmailContainer>
          {errorUserAlreadyRegistered && (
            <MessagePopUp
              title={'Erro!'}
              message={
                'O email já está cadastrado. Por favor insira outro email!'
              }
              isError
            >
              <ButtonPrimary
                fullWidth
                tema={tema}
                onClick={() => setErrorUserAlreadyRegistered(false)}
              >
                FECHAR
              </ButtonPrimary>
            </MessagePopUp>
          )}
        </BaseComponentChangeData>
      )}
    </>
  );
};

export default ChangeEmail;
